import styled from 'styled-components';

export const MatchAction = styled.button.attrs({
    className: 'c-match-action c-match-item',
})`
    background: ${({ theme }) => theme.colors.deepBlue};
    border: 0;
    border-radius: 0.4rem;
    color: ${({ theme }) => theme.colors.white};
    padding: 1rem 1.6rem;
    flex: 1 1 auto;
    font-size: 1.2rem;
    font-weight: 600;
    white-space: nowrap;

    .icon {
        font-size: 1.6rem;
        transform: translateY(2px);
    }

    &[disabled] {
        background: ${({ theme }) => theme.colors.lightGray} !important;
        color: ${({ theme }) => theme.colors.black} !important;
        opacity: 0.5;
    }

    &.icon-only {
        flex: 0 0 4rem;
        padding: 0.8rem 0;
        width: 4rem;
    }
    &.secondary {
        background: ${({ theme }) => theme.colors.energyBlue};
        color: ${({ theme }) => theme.colors.white};
    }
    &.options {
        background: ${({ theme }) => theme.colors.whiteDarker};
        color: ${({ theme }) => theme.colors.gray};
    }
    &.options-extended {
        align-items: center;
        background: ${({ theme }) => theme.colors.white};
        border: 2px solid #c3c6d0;
        color: ${({ theme }) => theme.colors.blue};
        display: flex;
        gap: 0.4rem;
    }

    &.stage-1 {
        background: #0094f9;
        color: ${({ theme }) => theme.colors.white};
    }
    &.stage-1.secondary {
        background: ${({ theme }) => theme.colors.purple};
        color: ${({ theme }) => theme.colors.white};
    }

    &.stage-2 {
        background: ${({ theme }) => theme.colors.stage2};
        color: ${({ theme }) => theme.colors.white};
    }

    &.stage-3 {
        background: ${({ theme }) => theme.colors.stage3};
        color: ${({ theme }) => theme.colors.white};
    }
`;
export const MatchActionInline = styled(MatchAction)`
    flex: 0 0 auto;
`;

export const MatchActions = styled.div.attrs({
    className: 'c-match-actions',
})`
    align-items: stretch;
    display: flex;
    flex-direction: row;
    gap: 0.4rem;
    width: 100%;
`;
